// frontend/src/services/setupAuth.js
import api from './api';
import authService from './authService';

// Initialize authentication on app start
export const initializeAuth = async () => {
  console.log('🚀 Initializing authentication...');
  
  try {
    // 1. Fetch CSRF token first
    console.log('🔐 Fetching CSRF token...');
    await api.fetchCsrfToken();
    
    // 2. Check if user is already logged in
    if (authService.isAuthenticated()) {
      console.log('👤 User is authenticated, checking token validity...');
      
      // Check if token is still valid
      const isValid = await authService.checkAuthWithRefresh();
      
      if (isValid) {
        console.log('✅ Token is valid, loading user profile...');
        // Load user profile
        try {
          await authService.getProfile();
          console.log('✅ User profile loaded successfully');
        } catch (profileError) {
          console.warn('⚠️ Failed to load user profile:', profileError);
        }
      } else {
        console.log('❌ Token is invalid, clearing auth...');
        authService.logout();
      }
    } else {
      console.log('👤 No authenticated user found');
    }
    
    // 3. Test API connection
    console.log('🌐 Testing API connection...');
    try {
      const response = await api.get('/auth/csrf-token/');
      console.log('✅ API connection successful:', response.status);
    } catch (error) {
      console.warn('⚠️ API connection test failed:', error.message);
    }
    
    console.log('🎉 Auth initialization complete');
    return true;
  } catch (error) {
    console.error('❌ Auth initialization failed:', error);
    return false;
  }
};

// Check auth status periodically
let authCheckInterval = null;

export const startAuthMonitoring = () => {
  if (authCheckInterval) {
    clearInterval(authCheckInterval);
  }
  
  // Check auth every 5 minutes
  authCheckInterval = setInterval(async () => {
    if (authService.isAuthenticated()) {
      try {
        await authService.checkAuthWithRefresh();
      } catch (error) {
        console.log('Periodic auth check failed:', error);
      }
    }
  }, 5 * 60 * 1000); // 5 minutes
  
  console.log('🔒 Auth monitoring started');
};

export const stopAuthMonitoring = () => {
  if (authCheckInterval) {
    clearInterval(authCheckInterval);
    authCheckInterval = null;
    console.log('🔒 Auth monitoring stopped');
  }
};

// Call this in your main App.js or index.js
